<template src="./OrderSummary.html"/>
<style lang="scss" scoped src="./OrderSummary.scss"/>
<script>
import {
    SfButton,
    SfProperty,
    SfPrice,
    SfDivider,
    SfIcon,
    SfCircleIcon

} from '@storefront-ui/vue';
import Api from "@/api/Api";
import icons from "@/utils/icons";


export default {
    name: 'OrderSummary',
    components: {
        SfDivider,
        SfCircleIcon,
        SfIcon,
        SfPrice,
        SfButton,
        SfProperty
    },
    data() {
        return {
            icons: icons,
        }
    },
    computed: {
        currentCart: {
            get() {
                return this.$store.getters.getCart
            },
        },
    },

    methods: {
        goToCheckout() {
            this.$router.push(this.$localizePath('/commande/livraison'));
        },
        removeCoupon() {
            Api.cart.removeCoupon()
                .then((data) => {
                    this.$store.dispatch('setCart', data);
                })
                .catch((e) => {
                    console.error(e);
                    switch (e.status) {
                        case 409:
                            this.$store.dispatch('sendNotification', {
                                type: 'danger',
                                message: this.$i18n.t('coupon.allready'),
                                icon: icons.error
                            });
                            break;
                        case 404:
                            this.$store.dispatch('sendNotification', {
                                type: 'danger',
                                message: this.$i18n.t('coupon.not'),
                                icon: icons.error
                            });
                            break;
                        default:
                            break
                    }

                })
                .finally();

        },
    }

};
</script>


